<div class="account-details">
  <h2>Account Detail</h2>

  <div class="grid-x grid-padding-x" data-cy="account-details">
    <div class="medium-6 large-8 cell page__divider form-container padding-right-2">
      <rav-form
        *ngIf="scope.hasAccess(scope.scope.AccountWrite)"
        [formGroup]="formGroup"
        (formSubmit)="updateAccount($event)"
        [hasCancel]="true"
        (cancel)="getAccountDetail()"
        buttonText="Save"
        [successMessage]="successMessage"
      >
        <div class="grid-x grid-padding-x small-up-1 large-up-2">
          <div class="cell">
            <label>Account Name (e.g. Company)</label>
            <rav-input [controlFormGroup]="formGroup" controlName="name" [hasLabel]="false"></rav-input>
          </div>
          <div class="cell">
            <rav-input [controlFormGroup]="formGroup" controlName="phone_number"></rav-input>
          </div>
          <div class="cell">
            <rav-input [controlFormGroup]="formGroup" controlName="address_1"></rav-input>
          </div>
          <div class="cell">
            <rav-input [controlFormGroup]="formGroup" controlName="address_2"></rav-input>
          </div>
          <div class="cell">
            <rav-input [controlFormGroup]="formGroup" controlName="city"></rav-input>
          </div>
          <div class="cell">
            <rav-select [controlFormGroup]="formGroup" controlName="state" [selectOptions]="states"></rav-select>
          </div>
          <div class="cell">
            <label>Zip Code</label>
            <rav-input [controlFormGroup]="formGroup" controlName="postal_code" [hasLabel]="false"></rav-input>
          </div>
        </div>
      </rav-form>

      <div *ngIf="!scope.hasAccess(scope.scope.AccountWrite)">
        <div class="grid-x grid-padding-x grid-padding-y small-up-1 medium-up-2">
          <div class="cell">
            <h5>Name</h5>
            <p class="dark-gray-color">{{ account?.name }}</p>
          </div>
          <div class="cell">
            <h5>Phone Number</h5>
            <p class="dark-gray-color">{{ conformedPhoneNumber }}</p>
          </div>
          <div class="cell">
            <h5>Address 1</h5>
            <p class="dark-gray-color">{{ account?.street1 }}</p>
          </div>
          <div class="cell" *ngIf="account?.street2">
            <h5>Address 2</h5>
            <p class="dark-gray-color">{{ account?.street2 }}</p>
          </div>
          <div class="cell">
            <h5>City</h5>
            <p class="dark-gray-color">{{ account?.city }}</p>
          </div>
          <div class="cell">
            <h5>State</h5>
            <p class="dark-gray-color">{{ account?.state }}</p>
          </div>
          <div class="cell">
            <h5>Postal Code</h5>
            <p class="dark-gray-color">{{ account?.postal_code }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="medium-6 large-4 cell">
      <div class="page__margin">
        <h5>Account ID</h5>
        <p class="dark-gray-color">{{ account?.id }}</p>
      </div>
      <div class="page__margin">
        <h5>Raven Email Address</h5>
        <p *ngIf="ravenEmail" class="dark-gray-color word-break">
          <ng-container *ngIf="localStorage.userWithToken?.role === UserRole.Owner; else elseBlock">
            <rav-editor
              [currentText]="emailUsername"
              [editType]="'ravenEmail'"
              [showIconOnHover]="false"
              [editorClass]="'inbound-email'"
              [id]="'ravenEmail'"
              [textAppended]="emailDomain"
              (editionEvent)="onEditEmailAddress($event)"
            ></rav-editor>
          </ng-container>
          <ng-template #elseBlock>
            {{ ravenEmail }}
          </ng-template>
        </p>
        <p *ngIf="!ravenEmail" class="dark-gray-color">No Raven email address assigned.</p>
      </div>
      <div class="page__margin">
        <h5>Storage Used</h5>
        <p class="dark-gray-color">{{ accountStorageTotals?.documents | accountStorageUsage }}</p>
      </div>
      <hr />
      <div class="margin-vertical-2 margin-horizontal-1">
        <h5>Need Help?</h5>
        <p>Click <a (click)="onHelpClick()">here</a> to contact one of our representatives to assist you.</p>
      </div>
    </div>
  </div>
</div>

<div class="account-settings margin-top-1" *ngIf="localStorage.userWithToken?.role === UserRole.Owner">
  <h2>Account Settings</h2>
  <div class="grid-x grid-padding-x margin-top-2">
    <div class="cell medium-8 large-10 padding-right-2">
      <div class="grid-padding-x large-up-2">
        <div class="cell">
          <label
            >Permanent File Deletions
            <rav-icon
              matTooltip="Ability to delete from Trash"
              matTooltipPosition="above"
              [name]="RavIconCircled.Question"
              class="question"
            ></rav-icon>
          </label>
          <select
            data-cy="permanentDeletionDropdown"
            [(value)]="permanentDeletionEnabled"
            (change)="onPermanentDeletionChange($event)"
          >
            <option *ngFor="let option of permanentDeletionOptions" [value]="option.value">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="cell">
          <label
            >History
            <rav-icon
              matTooltip="Show and record history of uploaded and sent documents"
              matTooltipPosition="above"
              [name]="RavIconCircled.Question"
              class="question"
            ></rav-icon>
          </label>
          <select data-cy="showHistoryDropdown" [(value)]="showHistoryEnabled" (change)="onShowHistoryChange($event)">
            <option *ngFor="let option of showHistoryOptions" [value]="option.value">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="cell" *ngIf="canUserE2EEncryption()">
          <label
            >End-to-End Document Encryption
            <rav-icon
              matTooltip="Automatically encrypt all your documents among your account."
              matTooltipPosition="above"
              [name]="RavIconCircled.Question"
              class="question"
            >
            </rav-icon>
          </label>
          <div class="cell">
            <select
              data-cy="documentE2eEncryptionDropdown"
              [ngModel]="documentE2eEncryptionEnabled"
              (ngModelChange)="onDocumentE2eEncryptionChange($event)"
              (input)="preventSelect($event)"
            >
              <option *ngFor="let option of documentE2eEncryptionOptions" [value]="option.value">
                {{ option.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="cell medium-8 large-10 padding-right-2 reset-policy-container">
      <rav-password-reset-policy
        (updatePolicy)="onUpdateResetPasswordPolicy($event)"
        [resetPolicy]="accountExpiresIn"
        [disabled]="
          documentE2eEncryptionStatus === AccountE2eEncryption.Active ||
          documentE2eEncryptionStatus === AccountE2eEncryption.Activating
        "
      ></rav-password-reset-policy>
      <div class="loading" *ngIf="isUpdatingPasswordResetPolicy">
        <img class="loader__image" src="/assets/images/loading.gif" alt="Loading spinner" />
      </div>
    </div>

    <div class="cell medium-8 large-10 padding-right-2 reset-policy-container">
      <rav-two-factor-auth
        (twoFactorAuthChange)="onTwoFactorAuthChanged($event)"
        [twoFactorAuth]="twoFactorAuthRequired"
      ></rav-two-factor-auth>
    </div>
  </div>
</div>

<rav-e2e-encryption-modal [isEnable]="documentE2eEncryptionEnabled"></rav-e2e-encryption-modal>
<rav-extra-authentication></rav-extra-authentication>
